function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "diku25pa7a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4504",
    style: {
      fill: "#17ae7b"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "product-icn",
    style: {
      clipPath: "url(#diku25pa7a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 65999",
    d: "M15.683 3.829 8.1.039a.362.362 0 0 0-.323 0L.2 3.829a.361.361 0 0 0-.2.323v7.58a.361.361 0 0 0 .2.323l7.58 3.79a.362.362 0 0 0 .323 0l7.58-3.79a.361.361 0 0 0 .2-.323v-7.58a.361.361 0 0 0-.2-.323M7.941.765l6.773 3.387-1.449.724-6.772-3.387zm2.437 5.555L3.6 2.933l2.081-1.04 6.777 3.387zm.271.672 2.166-1.083v2.685l-.693-.494a.361.361 0 0 0-.507.088l-.966 1.4zM2.8 3.337l6.771 3.387-1.629.815-6.774-3.387zM.722 4.736 7.58 8.165v6.773L.722 11.509zm7.58 10.2V8.165l1.624-.812v3.387a.361.361 0 0 0 .658.206L12 8.9l.965.689a.361.361 0 0 0 .571-.294V5.548l1.624-.812v6.773z",
    transform: "translate(1.904 1.906)",
    style: {
      fill: "#6200ee"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcn);
export default __webpack_public_path__ + "static/media/product-icn.a68321788c63353086c42cbff35b6c29.svg";
export { ForwardRef as ReactComponent };